/**
 * Registry of score-based games that have an all-time leaderboard.
 *
 * Order = tab order in the leaderboard sheet. Adding a score-based game is one entry here (and one in
 * the server allowlist `server/src/constants/games/leaderboardGames.js`). Daily games (Wordle) are
 * intentionally absent — they're not a high-score race. See specs/mini-games-leaderboard/spec.md.
 */

import { BLOCKY_STRIKER_GAME_KEY } from './blockyStriker.constants';
import { HILO_GAME_KEY } from './higherLower.constants';
import { KEEPER_DUEL_GAME_KEY } from './keeperDuel.constants';

export interface LeaderboardGame {
  /** Server gameKey (matches the server allowlist). */
  gameKey: string;
  /** Tab label. */
  label: string;
  /** What the ranked score represents, shown as the board subtitle (e.g. "Best run"). */
  metricLabel: string;
}

export const LEADERBOARD_GAMES: readonly LeaderboardGame[] = [
  { gameKey: HILO_GAME_KEY, label: 'Higher or Lower', metricLabel: 'Best run' },
  { gameKey: KEEPER_DUEL_GAME_KEY, label: 'Keeper Duel', metricLabel: 'Best streak' },
  { gameKey: BLOCKY_STRIKER_GAME_KEY, label: 'Blocky Striker', metricLabel: 'Best goals' },
] as const;
